/* Souq & Silk — storefront behaviour. No dependencies. */
(function () {
  'use strict';

  /* ---------- mobile drawer ---------------------------------------------- */
  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-drawer-open]');
    if (open) {
      var dialog = document.getElementById('menu-drawer');
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }
    var close = event.target.closest('[data-drawer-close]');
    if (close) {
      close.closest('dialog').close();
    }
  });

  /* clicking the backdrop closes the drawer */
  document.querySelectorAll('dialog.drawer').forEach(function (dialog) {
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  });

  /* ---------- quantity steppers ------------------------------------------ */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty]');
    if (!button) return;
    var input = button.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var step = parseInt(button.getAttribute('data-qty'), 10) || 1;
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var next = (parseInt(input.value, 10) || 0) + step;
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product variant picker ------------------------------------- */
  var variantData = document.getElementById('product-variants');
  var form = document.getElementById('product-form');
  if (variantData && form) {
    var variants = JSON.parse(variantData.textContent);
    var idInput = document.getElementById('product-variant-id');
    var addButton = document.getElementById('product-add');
    var priceBox = document.getElementById('product-price');
    var radios = form.querySelectorAll('.opt__choice');

    var selectedOptions = function () {
      var picked = [];
      radios.forEach(function (radio) {
        if (radio.checked) picked[parseInt(radio.getAttribute('data-option-position'), 10) - 1] = radio.value;
      });
      return picked;
    };

    var findVariant = function (options) {
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return value === options[index];
        });
      });
    };

    var formatMoney = function (cents) {
      return window.Shopify && Shopify.formatMoney ? Shopify.formatMoney(cents) : (cents / 100).toFixed(2);
    };

    var update = function () {
      var variant = findVariant(selectedOptions());
      if (!variant) return;
      idInput.value = variant.id;

      if (priceBox) {
        var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceBox.innerHTML =
          '<p class="price price--lg">' +
          (sale
            ? '<span class="price__sale">' + formatMoney(variant.price) + '</span>' +
              '<span class="price__compare">' + formatMoney(variant.compare_at_price) + '</span>'
            : '<span>' + formatMoney(variant.price) + '</span>') +
          '</p>';
      }

      if (addButton) {
        addButton.disabled = !variant.available;
        var label = variant.available
          ? addButton.getAttribute('data-label-add')
          : addButton.getAttribute('data-label-sold');
        if (label) addButton.textContent = label;
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    radios.forEach(function (radio) {
      radio.addEventListener('change', update);
    });
  }

  /* ---------- product gallery -------------------------------------------- */
  var main = document.querySelector('.product__main');
  if (main) {
    var mainImage = main.querySelector('img');
    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        document.querySelectorAll('[data-thumb]').forEach(function (other) {
          other.setAttribute('aria-current', 'false');
        });
        thumb.setAttribute('aria-current', 'true');
        if (!mainImage) return;
        mainImage.src = thumb.getAttribute('data-src');
        mainImage.srcset = thumb.getAttribute('data-srcset');
      });
    });
  }

  /* ---------- language switcher ------------------------------------------- */
  document.querySelectorAll('[data-lang-switch]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.form;
      if (form) form.submit();
    });
  });

  /* ---------- smooth anchor offset for the sticky header ------------------ */
  document.documentElement.style.scrollPaddingTop = '90px';
})();
